/* tslint:disable */
/* eslint-disable */
/**
 * esign
 * eSign template authoring and request management service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const EsignRequestPrimaryAction = {
    OpenSetup: 'open_setup',
    ViewDetails: 'view_details',
    None: 'none',
} as const;
export type EsignRequestPrimaryAction = typeof EsignRequestPrimaryAction[keyof typeof EsignRequestPrimaryAction];


export function instanceOfEsignRequestPrimaryAction(value: any): boolean {
    for (const key in EsignRequestPrimaryAction) {
        if (Object.prototype.hasOwnProperty.call(EsignRequestPrimaryAction, key)) {
            if (EsignRequestPrimaryAction[key as keyof typeof EsignRequestPrimaryAction] === value) {
                return true;
            }
        }
    }
    return false;
}

export function EsignRequestPrimaryActionFromJSON(json: any): EsignRequestPrimaryAction {
    return EsignRequestPrimaryActionFromJSONTyped(json, false);
}

export function EsignRequestPrimaryActionFromJSONTyped(json: any, ignoreDiscriminator: boolean): EsignRequestPrimaryAction {
    return json as EsignRequestPrimaryAction;
}

export function EsignRequestPrimaryActionToJSON(value?: EsignRequestPrimaryAction | null): any {
    return value as any;
}

export function EsignRequestPrimaryActionToJSONTyped(value: any, ignoreDiscriminator: boolean): EsignRequestPrimaryAction {
    return value as EsignRequestPrimaryAction;
}

